import React from 'react';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      width: theme.spacing(10),
    },
  }),
);

interface Props {
  src: string;
}

const Thumbnail: React.FC<Props> = ({ src }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <img src={src} alt='Thumbnail' width='100%' height='100%' />
    </div>
  );
};

export default Thumbnail;
